// Chakra Imports
import {
    Avatar,
    Button,
    Flex,
    Icon,
    Image,
    Link,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Text,
    Spinner,
    Box,
    useColorModeValue,
} from "@chakra-ui/react";
import { MdLogout, MdAccountCircle, MdSettings } from "react-icons/md";
// Custom Components
import { ItemContent } from "components/menu/ItemContent";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import React from "react";
// Assets
import navImage from "assets/img/layout/Navbar.png";
import { MdNotificationsNone } from "react-icons/md";
import { FaEthereum } from "react-icons/fa";
import routes from "routes.js";
import { ThemeEditor } from "./ThemeEditor";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "pages/auth/authSlice";
import { useLogoutUserMutation } from "store/apis/authApi";
import { useGetCurrentUserQuery } from "store";
import { useNavigate } from "react-router-dom";

export default function HeaderLinks(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [logoutUser, { isLoading: ahLoad }] = useLogoutUserMutation();

    // const handleLogout = () => {
    //     // Clear user data from redux
    //     dispatch(logOut());

    //     localStorage.clear();
    // };

    const { data: currentUser, error, isLoading } = useGetCurrentUserQuery();
    const username = currentUser?.username || "Guest";

    const handleProfile = () => {
        navigate(`/profile`);
    };

    const handleSettings = () => {
        navigate(`/settings`);
    };

    const handleLogout = async () => {
        try {
            await logoutUser();
        } catch (error) {
            console.error("Failed to log out", error);
        }
    };

    const { secondary } = props;
    // Chakra Color Mode
    const navbarIcon = useColorModeValue("gray.400", "white");
    let menuBg = useColorModeValue("white", "navy.800");
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const textColorBrand = useColorModeValue("brand.700", "brand.400");
    const ethColor = useColorModeValue("gray.700", "white");
    const borderColor = useColorModeValue(
        "#E6ECFA",
        "rgba(135, 140, 189, 0.3)"
    );
    const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
    const ethBox = useColorModeValue("white", "navy.800");
    const shadow = useColorModeValue(
        "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
        "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
    );
    const borderButton = useColorModeValue(
        "secondaryGray.500",
        "whiteAlpha.200"
    );

    // Handle loading state
    if (isLoading)
        return (
            <Box display="flex" justifyContent="center">
                <Spinner size="xl" />
            </Box>
        );

    // Handle error state
    if (error)
        return (
            <Text>
                Error: {error.message || "Failed to load user information"}
            </Text>
        );

    return (
        <Flex
            w={{ base: "auto", md: "auto" }}
            alignItems="center"
            justifyContent="space-between"
            bg={menuBg}
            flexWrap="nowrap"
            p="10px"
            borderRadius="30px"
            boxShadow={shadow}
            flexDirection={{ base: "row", md: "row" }}
        >
            {/* Sidebar for Responsive Navigation */}
            <Box display={{ base: "flex", md: "flex" }}>
                <SidebarResponsive routes={routes} />
            </Box>

            {/* <Menu>
                <MenuButton p="0px">
                    <Icon
                        mt="6px"
                        as={MdNotificationsNone}
                        color={navbarIcon}
                        w="18px"
                        h="18px"
                        me="10px"
                    />
                </MenuButton>

                <MenuList
                    boxShadow={shadow}
                    p="20px"
                    borderRadius="20px"
                    bg={menuBg}
                    border="none"
                    mt="22px"
                    me={{ base: "30px", md: "unset" }}
                    minW={{ base: "unset", md: "400px", xl: "450px" }}
                    maxW={{ base: "360px", md: "unset" }}
                >
                    <Flex jusitfy="space-between" w="100%" mb="20px">
                        <Text fontSize="md" fontWeight="600" color={textColor}>
                            Notifications
                        </Text>
                        <Text
                            fontSize="sm"
                            fontWeight="500"
                            color={textColorBrand}
                            ms="auto"
                            cursor="pointer"
                        >
                            Mark all read
                        </Text>
                    </Flex>
                    <Flex flexDirection="column">
                        <MenuItem
                            _hover={{ bg: "none" }}
                            _focus={{ bg: "none" }}
                            px="0"
                            borderRadius="8px"
                            mb="10px"
                        >
                            <ItemContent
                                info="Horizon UI Dashboard PRO"
                                aName="Alicia"
                            />
                        </MenuItem>
                        <MenuItem
                            _hover={{ bg: "none" }}
                            _focus={{ bg: "none" }}
                            px="0"
                            borderRadius="8px"
                            mb="10px"
                        >
                            <ItemContent
                                info="Horizon Design System Free"
                                aName="Josh Henry"
                            />
                        </MenuItem>
                    </Flex>
                </MenuList>
            </Menu> */}

            {/* <ThemeEditor navbarIcon={navbarIcon} /> */}

            <Menu>
                <MenuButton p="0px">
                    <Avatar
                        _hover={{ cursor: "pointer" }}
                        color="white"
                        name={currentUser.first_name}
                        bg="#11047A"
                        size="sm"
                        w="40px"
                        h="40px"
                    />
                </MenuButton>
                <MenuList
                    boxShadow={shadow}
                    p="0px"
                    mt="10px"
                    borderRadius="20px"
                    bg={menuBg}
                    border="none"
                    zIndex="dropdown"
                >
                    <Flex w="100%" mb="0px">
                        <Text
                            ps="20px"
                            pt="16px"
                            pb="10px"
                            w="100%"
                            borderBottom="1px solid"
                            borderColor={borderColor}
                            fontSize="sm"
                            fontWeight="700"
                            color={textColor}
                        >
                            👋&nbsp; Hey, {username}
                        </Text>
                    </Flex>
                    <Flex flexDirection="column" p="10px">
                        <MenuItem
                            _hover={{ bg: "none" }}
                            _focus={{ bg: "none" }}
                            borderRadius="8px"
                            px="14px"
                            onClick={handleProfile}
                        >
                            <Icon
                                as={MdAccountCircle}
                                width="20px"
                                height="20px"
                                marginRight={2}
                                color="inherit"
                            />
                            <Text fontSize="sm">Profile</Text>
                        </MenuItem>

                        <MenuItem
                            _hover={{ bg: "none" }}
                            _focus={{ bg: "none" }}
                            borderRadius="8px"
                            px="14px"
                            onClick={handleSettings}
                        >
                            <Icon
                                as={MdSettings}
                                width="20px"
                                height="20px"
                                marginRight={2}
                                color="inherit"
                            />
                            <Text fontSize="sm">Settings</Text>
                        </MenuItem>

                        <MenuItem
                            _hover={{ bg: "none" }}
                            _focus={{ bg: "none" }}
                            color="red.400"
                            borderRadius="8px"
                            px="14px"
                            isLoading={ahLoad}
                            onClick={handleLogout}
                        >
                            <Icon
                                as={MdLogout}
                                width="20px"
                                height="20px"
                                marginRight={2}
                                color="inherit"
                            />
                            <Text fontSize="sm">Log out</Text>
                        </MenuItem>
                    </Flex>
                </MenuList>
            </Menu>
        </Flex>
    );
}

HeaderLinks.propTypes = {
    variant: PropTypes.string,
    fixed: PropTypes.bool,
    secondary: PropTypes.bool,
    onOpen: PropTypes.func,
};
